import React from 'react';
import { util } from 'veritone-redux-common';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
// import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import CircularProgress from '@material-ui/core/CircularProgress';

import {
  userIsAuthenticated,
  getReferrer,
  selectUserOrganizationKvp,
} from 'modules/user';
import { isLoading } from 'modules/loading';
import {
  selectSnackbarNotificationState,
  hideSnackbarNotification,
  hideDialogNotification,
} from 'modules/snackbar';
import { changeSidebarMode, selectCollapsedSidebar } from 'modules/sidebar';
import { initSegment } from '../../helpers/analyticsHelper';

import {
  selectDocumentationState,
  hideDocumentation,
} from 'modules/documentation';
import rootSaga from './modules/sagas';

import { element, bool, shape, string, func, objectOf, any } from 'prop-types';

import FakeLoadingBar from 'shared-components/FakeLoadingBar';
import GlobalSnackBar from 'shared-components/GlobalSnackBar';
import GlobalNotificationDialog from 'shared-components/GlobalNotificationDialog';
import GlobalConfirmationDialogs from 'shared-components/GlobalConfirmationDialogs';
import TopBar from 'shared-components/TopBar';

import styles from './styles/appContainer.scss';
import { selectDialogNotificationState } from '../../modules/snackbar';
import { getConfig } from 'modules/config';
import GlobalDocumentation from 'shared-components/GlobalDocumentation';

import SideBar from 'shared-components/SideBar';
import sitemap from './site-map';

const saga = util.reactReduxSaga.saga;
@saga(rootSaga)
@connect(
  (state) => ({
    isCollapsedSidebar: selectCollapsedSidebar(state),
    snackBar: selectSnackbarNotificationState(state),
    dialogNotification: selectDialogNotificationState(state),
    documentation: selectDocumentationState(state),
    loading: isLoading(state),
    userIsAuthenticated: userIsAuthenticated(state),
    graphqlUri: getConfig(state).services.graphqlUri,
    userReferredBy: getReferrer(state),
    userOrgKvp: selectUserOrganizationKvp(state),
    segment: initSegment(state),
  }),
  {
    hideSnackbarNotification,
    hideDialogNotification,
    hideDocumentation,
    changeSidebarMode,
  }
)
export default class App extends React.Component {
  static propTypes = {
    children: element.isRequired,
    snackBar: shape({
      open: bool,
      message: string,
    }),
    dialogNotification: shape({
      open: bool,
      title: string,
      message: string,
    }),
    hideSnackbarNotification: func.isRequired,
    hideDialogNotification: func.isRequired,
    loading: bool,
    userIsAuthenticated: bool,
    graphqlUri: string,
    hideDocumentation: func.isRequired,
    documentation: shape({
      open: bool,
      source: string,
    }),
    userReferredBy: string,
    userOrgKvp: objectOf(any),
    isCollapsedSidebar: bool,
    changeSidebarMode: func,
  };

  state = {
    currentChildren: this.props.children,
    pendingChildren: null,
    appBarLoaded: false,
  };

  componentDidMount() {
    this.checkAppbar();
  }

  checkAppbar = () => {
    if (window.aiware) {
      this.initAiware();
      this.setState({ appBarLoaded: true });
    } else {
      setTimeout(() => {
        this.checkAppbar();
      }, 1000);
    }
  };

  changeSidebarMode = () => {
    this.props.changeSidebarMode();
  };

  initAiware = () => {
    let graphQLEndpoint = this.props.graphqlUri || '';
    const applicationId = 'b9dba7b8-501a-4219-995b-5e6eadfb5ae0'; // TODO: get this value dynamically
    let aiwareParams = {
      applicationId,
      baseUrl: graphQLEndpoint,
      withAuth: true,
    };
    if (window.Cypress) {
      aiwareParams.baseUrl = graphQLEndpoint;
      aiwareParams.authToken = window.Cypress.token;
    }
    window.aiware.init(aiwareParams, () => {
      window.aiware.mountWidget({
        name: 'APP_BAR',
        elementId: 'aiware-app-bar',
        config: {
          title: 'Developer',
          backgroundColor: '#325491',
          help: true,
          zIndex: 1,
          leftNav: true,
          onClickAppbarMenu: this.changeSidebarMode,
        },
      });
      window.aiware.on('openSupport', async () => {
        try {
          await window.chatWithSupport();
        } catch (err) {
          console.log(err || 'Error initializing chat');
        }
      });
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.loading) {
      this.setState({
        currentChildren: nextProps.children || this.state.currentChildren,
        pendingChildren: null,
      });
    }

    if (nextProps.children !== this.state.currentChildren) {
      if (nextProps.loading) {
        this.setState({
          pendingChildren: nextProps.children,
        });
      } else {
        this.setState({
          currentChildren: nextProps.children,
          pendingChildren: null,
        });
      }
    }
  }

  render() {
    const { isCollapsedSidebar } = this.props;
    let env = this.props.graphqlUri.split('.')[1];
    env = env !== 'veritone' ? `${env}.` : '';

    const isAnywhere = window.config.isAnywhere || false;
    const sideBarMenu = [...sitemap(env)].filter((item) => {
      if (isAnywhere && item.removeFromAnywhere) {
        return false;
      }

      return true;
    });

    return (
      <div className={styles.appContainer}>
        {this.state.appBarLoaded ? (
          <React.Fragment>
            {this.props.loading && <FakeLoadingBar />}
            {this.props.userIsAuthenticated && (
              <TopBar appBarOffset isCollapsed={isCollapsedSidebar} />
            )}
            {this.props.userIsAuthenticated && (
              <SideBar
                topBarOffset
                items={sideBarMenu}
                isCollapsed={isCollapsedSidebar}
              />
            )}
            {this.state.currentChildren}
            <GlobalSnackBar
              open={this.props.snackBar.open}
              message={this.props.snackBar.message}
              onClose={this.props.hideSnackbarNotification}
              className={styles.snackBar}
            />
            <GlobalNotificationDialog
              open={this.props.dialogNotification.open}
              title={this.props.dialogNotification.title}
              message={this.props.dialogNotification.message}
              onRequestClose={this.props.hideDialogNotification}
            />
            <GlobalConfirmationDialogs />
            {this.props.documentation.open && (
              <GlobalDocumentation
                onClose={this.props.hideDocumentation}
                open={this.props.documentation.open}
                source={this.props.documentation.source}
              />
            )}
            <ReactTooltip delayShow={500} multiline class="globalToolTip" />
          </React.Fragment>
        ) : (
          <div className={styles.appBarContainer}>
            <CircularProgress />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/app/App.js